import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n/i18n";
import { migrateLegacyStorage } from "@/lib/storage";
import App from "@/App";
import { hideSplash, configureStatusBar, isNative } from "@/lib/native";

// One-time migration from legacy ricezione_* localStorage keys to xenia_*
migrateLegacyStorage();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Native shell (iOS / Android via Capacitor) — hide launch splash, set status bar
if (isNative()) {
  configureStatusBar();
  // Give the React tree ~600ms to paint before hiding splash
  setTimeout(() => { hideSplash(); }, 600);
}

// Register service worker (PWA) — only on web, not inside Capacitor native shell
if ("serviceWorker" in navigator && window.location.protocol === "https:" && !isNative()) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
